/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import {
  InputAttributes,
  NumericFormat as ReactNumericFormat,
} from "react-number-format";
import type { NumericFormatSharedProps } from "./NumericFormat.props";

export default function NumericFormat(props: NumericFormatProps): JSX.Element {
  const { getInputRef, customInput } = props;
  return (
    <ReactNumericFormat
      {...props}
      getInputRef={
        getInputRef
          ? (getInputRef as (el: HTMLInputElement) => void | React.Ref<any>)
          : undefined
      }
      customInput={
        customInput
          ? (customInput as React.ComponentType<InputAttributes>)
          : null
      }
    />
  );
}

export type NumericFormatProps = NumericFormatSharedProps & {
  // Add any web specific props here.
};
